import { env } from '@/config/env';

const normalizeEnvValue = (value?: string): string => value?.trim().toLowerCase() ?? '';

function isProductionEnvironment(): boolean {
  const appEnv = normalizeEnvValue(env.VITE_APP_ENV);
  const environment = normalizeEnvValue(env.VITE_ENVIRONMENT);
  const mode = normalizeEnvValue(import.meta.env.MODE);

  if (appEnv || environment) {
    return appEnv === 'production' || environment === 'production';
  }

  return mode === 'production';
}

export const SMS_UI_DISABLED_MESSAGE =
  'SMS setup is temporarily unavailable while toll-free verification is in review.';

export function isSmsUiEnabled(): boolean {
  if (env.VITE_SMS_UI_ENABLED !== undefined) {
    return env.VITE_SMS_UI_ENABLED;
  }

  return !isProductionEnvironment();
}
